import { render } from "./EditSkills.vue?vue&type=template&id=cae50024"
import script from "./EditSkills.vue?vue&type=script&lang=js"
export * from "./EditSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__